import style from './HasNoWarrantyStyle.module.css';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';

export const HasNoWarranty = () => {
  return (
    <RoundSheet>
      <div className={style.title}>
        <h3>現在契約中の保証プランはありません</h3>
      </div>
    </RoundSheet>
  );
};
